import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const DeleteChatHistoryMutation = graphql(`
  mutation DeleteChatHistory($id: ID!) {
    deleteChatHistory(id: $id) {
      id
      __typename
      client {
        id
        __typename
        name
        externalReference
      }
      sessionId
      messages
      createdAt
      updatedAt
    }
  }
`);

export function useDeleteChatHistory() {
  const [result, deleteChatHistoryMutation] = useMutation(DeleteChatHistoryMutation);
  const [error, setError] = useState<Error | null>(null);

  const deleteChatHistory = useCallback(
    async (id: string) => {
      try {
        const response = await deleteChatHistoryMutation({ id });
        if (response.error) {
          throw response.error;
        }
        return response.data?.deleteChatHistory;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [deleteChatHistoryMutation],
  );

  return { deleteChatHistory, result, error };
}
